import {create} from 'zustand';
import {SignUpFormDataStore} from './types';

const useSignUpFormDataStore = create<SignUpFormDataStore>(set => ({
	signUpFormData: {
		cdEmpresaPlano: [],
		cdPessoa: '',
		cdSenha: '',
		celular: '',
		dsEmailLogin: '',
		cpf: '',
		token: '',
		cdUsuario: '',
		identificador: '',
	},
	setSignUpFormData: value =>
		set(state => ({
			signUpFormData: typeof value === 'function' ? value(state.signUpFormData) : value,
		})),
}));

export {useSignUpFormDataStore};
